module.exports = __webpack_public_path__ + "img/vu.64c4943f.svg";